/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
} from './ChallengeType';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';
import type { PasswordResetChallengeOptions } from './PasswordResetChallengeOptions';
import {
    PasswordResetChallengeOptionsFromJSON,
    PasswordResetChallengeOptionsFromJSONTyped,
    PasswordResetChallengeOptionsToJSON,
} from './PasswordResetChallengeOptions';

/**
 * 
 * @export
 * @interface PasswordResetChallenge
 */
export interface PasswordResetChallenge {
    /**
     * 
     * @type {string}
     * @memberof PasswordResetChallenge
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof PasswordResetChallenge
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof PasswordResetChallenge
     */
    authentication_method: FactorMethod;
    /**
     * 
     * @type {PasswordResetChallengeOptions}
     * @memberof PasswordResetChallenge
     */
    options: PasswordResetChallengeOptions;
}

/**
 * Check if a given object implements the PasswordResetChallenge interface.
 */
export function instanceOfPasswordResetChallenge(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;
    isInstance = isInstance && "options" in value;

    return isInstance;
}

export function PasswordResetChallengeFromJSON(json: any): PasswordResetChallenge {
    return PasswordResetChallengeFromJSONTyped(json, false);
}

export function PasswordResetChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordResetChallenge {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
        'options': PasswordResetChallengeOptionsFromJSON(json['options']),
    };
}

export function PasswordResetChallengeToJSON(value?: PasswordResetChallenge | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': ChallengeTypeToJSON(value.type),
        'authentication_method': FactorMethodToJSON(value.authentication_method),
        'options': PasswordResetChallengeOptionsToJSON(value.options),
    };
}

